export default "__VITE_ASSET__BNS3lUHz__"